import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
export function EmotionalCloseSection() {
  const [ref, isInView] = useInView({
    threshold: 0.15
  });
  return <section className="relative min-h-[50vh] sm:min-h-[60vh] flex items-end justify-center overflow-hidden" data-id="element-166">
      <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/ChatGPT_Image_26_abr_2026_06_26_30_a.m.4.png?v=1777199448" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover object-center z-0" loading="lazy" decoding="async" data-id="element-167" />

      {/* Overlay */}
      <div className="absolute inset-0 z-[1]" style={{
      background: 'linear-gradient(0deg, #0A0A0B 15%, rgba(10,10,11,0.6) 50%, #0A0A0B 95%)'
    }} data-id="element-168" />

      {/* Golden glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-xl h-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.06),transparent_50%)] pointer-events-none z-[2]" data-id="element-169" />

      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 20
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.8
    }} className="relative z-10 text-center pb-16 sm:pb-24 px-4" data-id="element-170">
        <p className="font-serif text-xl sm:text-3xl font-bold text-white/90 max-w-lg mx-auto leading-relaxed drop-shadow-lg" data-id="element-171">
          El cambio no empieza mañana.
          <br data-id="element-172" />
          <span className="text-gold" data-id="element-173">Empieza cuando decides.</span>
        </p>
      </motion.div>
    </section>;
}